import { SatRec } from "satellite.js";

export type Tle = {
  name: string;
  firstLine: string;
  secondLine: string;
};

export const rsoType = {
  PAYLOAD: "PAYLOAD",
  ROCKET_BODY: "ROCKET BODY",
  DEBRIS: "DEBRIS",
  UNKNOWN: "UNKNOWN",
  ENEMY: "ENEMY"
};

export type RSOTypeKey = keyof typeof rsoType;

export type RSOTypeValue = (typeof rsoType)[keyof typeof rsoType];

export const subType = {
  STARLINK: "STARLINK",
  ONEWEB: "ONEWEB",
  OTHERS: "OTHERS",
  ROCKET_BODY: "ROCKET BODY",
  DEBRIS: "DEBRIS",
  UNKNOWN: "UNKNOWN",
  ENEMY: "ENEMY"
};

export type SubTypeKey = keyof typeof subType;
export type SubTypeValue = (typeof subType)[keyof typeof subType];

export type RSODatas = { [key: string]: RSOTypeValue };

export type SpaceObjectType = {
  noradId: number;
  name: string;
  satrec: SatRec;
  type: RSOTypeValue;
  subtype?: string;
};

export type SpaceObjectInstance = SpaceObjectType & {
  uuid?: string;
  instanceId?: number;
};

export type SpaceObjectGroup = SpaceObjectType & {
  uuid?: string;
};

export type Position = {
  x: number;
  y: number;
  z: number;
};

export type Datas = Position & {
  name: string;
};

export type SatDatasByType = {
  [type in RSOTypeValue]: Partial<{
    [subtype in SubTypeValue]: SpaceObjectType[];
  }>;
};

export type FilterType = {
  name: RSOTypeKey;
  enabled: boolean;
  subFilters: {
    name: SubTypeKey;
    enabled: boolean;
  }[];
};

export type CameraType = "PERSPECTIVE" | "ORTHOGRAPHIC";
